import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    PROCESSOR_ONBOARDING_LOAD,
    PROCESSOR_ONBOARDING_SUCCESS,
    PROCESSOR_ONBOARDING_FAILURE
} from './processorOnboardingActions';

export default function reducer(state = {}, action = {}) {
    let newState;
    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                processorOnboarding: []
            };

            return _.isEqual(state, newState) ? state : newState;

        case PROCESSOR_ONBOARDING_LOAD:
            newState = {
                ...state,
                processorOnboarding: [],
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case PROCESSOR_ONBOARDING_SUCCESS:
            newState = {
                ...state,
                processorOnboarding: action.processorOnboarding,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return _.isEqual(state, newState) ? state : newState;

        case PROCESSOR_ONBOARDING_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return _.isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getProcessorOnboardingEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'processorOnboarding')
);

export const getProcessorOnboarding = createSelector(
    getProcessorOnboardingEntity,
    (entity) => _.get(entity, 'processorOnboarding')
);

export const getIsProcessorOnboardingLoading = createSelector(
    getProcessorOnboardingEntity,
    (entity) => _.get(entity, 'loading')
);

export const getProcessorOnboardingError = createSelector(
    getProcessorOnboardingEntity,
    (entity) => _.get(entity, 'error')
);

export const getProcessorOnboardingErrorMessage = createSelector(
    getProcessorOnboardingError,
    (error) => _.get(error, 'message')
);

export const getPages = createSelector(
    getProcessorOnboardingEntity,
    (entity) => _.get(entity, 'pages')
);

export const getCount = createSelector(
    getProcessorOnboardingEntity,
    (entity) => _.get(entity, 'count')
);

export const getHasMore = createSelector(
    getProcessorOnboardingEntity,
    (entity) => _.get(entity, 'hasMore')
);
